import * as React from "react"
import { cn } from "../../lib/utils"
import { ChevronDown } from "lucide-react"

// Native select component for better mobile compatibility
const NativeSelect = React.forwardRef(({ 
  className, 
  value, 
  onValueChange, 
  children,
  placeholder,
  ...props 
}, ref) => {
  return (
    <div className="relative">
      <select
        ref={ref}
        value={value || ''}
        onChange={(e) => onValueChange?.(e.target.value)}
        className={cn(
          "flex h-12 w-full items-center justify-between rounded-md border border-input bg-slate-950 px-4 py-2 text-base text-white shadow-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-amber-500 disabled:cursor-not-allowed disabled:opacity-50 appearance-none cursor-pointer",
          className
        )}
        {...props}
      >
        {placeholder && (
          <option value="" disabled className="text-slate-500">
            {placeholder}
          </option>
        )}
        {children}
      </select>
      <ChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 h-5 w-5 text-slate-400 pointer-events-none" />
    </div>
  )
})
NativeSelect.displayName = "NativeSelect"

const NativeSelectOption = React.forwardRef(({ 
  className, 
  value,
  children,
  ...props 
}, ref) => {
  return (
    <option
      ref={ref}
      value={value}
      className={cn("bg-slate-900 text-white py-2", className)}
      {...props}
    >
      {children}
    </option>
  )
})
NativeSelectOption.displayName = "NativeSelectOption"

export { NativeSelect, NativeSelectOption }
